<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Meni</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Meni</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col class="d-flex mt-3" cols="12">
                    <v-data-table
                            class="mt-4"
                            hide-default-footer
                            style="width: 100%;border: 1px solid #ddd;border-radius: 0"
                            :headers="headers"
                            :items="items"
                            :loading="loading"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-btn depressed small tile color="success" :to="{name: 'meni-create'}">Dodaj novi meni</v-btn>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.option="{ item }">
                            <v-btn depressed color="primary" small tile :to="{name: 'meni-id-items', params: {id: item.id}}">Items</v-btn>
                            <v-btn depressed color="red" dark class="ml-3" small tile @click="remove(item)">Delete</v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-col>

        <confirm-dialog ref="confirmBox"></confirm-dialog>
    </v-row>
</template>

<script>
	import bitPage from "../../components/layout/page";
    import confirmDialog from '../../components/global/confirm';

	export default {
		components: {
			bitPage,
            confirmDialog
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Meni',
					disabled: true
				},
			],
			headers: [
				{text: 'ID', value: 'id'},
				{text: 'Name', value: 'name'},
				{text: 'Option', value: 'option'}
			],
			items: [],
            loading: false

		}),
        created(){
            this.loading = true
            this.axios.get(`/menu`).then(res => this.items = res.data).finally(()=> this.loading = false)
        },
        methods: {
            remove(item) {
                this.$refs.confirmBox.open('Remove menu item', 'Are you sure want to delete this menu item?')
                    .then(() => this.axios.delete(`/menu/${item.id}`).then(() => {
                        this.items.splice(this.items.indexOf(item), 1)
                    }))
            }
        }
	}
</script>
